<template>
    <div class="morningpage">
        <div class="columns">
            <div class="column is-3">
                <ul style="font-size:1.1em;"><p  class="title is-4">目次</p>
                    <li><a href="#what-is-morningpages">モーニングページとは？</a></li>
                    <li><a href="#how-to-morningpages">モーニングページのやり方</a></li>
                    <li><a href="#no-reading">モーニングページは8週間は読み返さない</a></li>
                    <li><a href="#effect">モーニングページの効果</a></li>
                    <li><a href="#syukan">モーニングページを習慣にするには？</a></li>
                </ul>
            </div>
            <div class="column">
                <h2 class="title is-3">モーニングページを始めよう！</h2>
                <img src="@/assets/morning_page.jpg">
                <h3 class="title is-4"  id="what-is-morningpages">モーニングページとは？</h3>
                    <p>モーニングページは、ジュリアキャメロン著「ずっとやりたかったことを、やりなさい」で紹介されている創造性を伸ばす方法で、毎朝起きたらすぐにノート３ページに自分の心に浮かぶまま文章を書く作業のことを言います。</p>
                    <p style="padding:20px 0 20px 0;"><a href="https://juliacameronlive.com/basic-tools/morning-pages/" target="_blank">The Artist Way</a></p>
                    <p>モーニングページは、朝一番に、心に浮かぶ言葉をそのまま書く行為です。元々は創造性を回復させるためのワークアウトの一つとして始まりました。日本でも人気があり、毎日多くの人がモーニングページを書いています。</p>
                <h3 class="title is-4"  id="how-to-morningpages">モーニングページのやり方</h3>
                    <p>モーニングページは誰でも簡単にすぐ始められます。一般的な方法を紹介します。</p>
                <h4 class="title is-5">ノートを用意する</h4>
                    <p>モーニングページに必要なのは、紙とペンだけです。大学ノートで十分です。（もちろん、このサイトならノートすら用意せずモーニングページが始められます！）</p>
                <h4 class="title is-5">朝起きてすぐに書き始める</h4>
                    <p>モーニングページは、日記とは違います。朝起きたらすぐに取り掛かりましょう。モーニングページは誰にも見せないので、どんなに不格好でも、ちゃんとした文章になっていなくても一向に構いません。気にせずに自分の心に浮かぶ言葉をノートに書き写すイメージで書きましょう。</p>
                <h4 class="title is-5">ノート3ページ分が目安</h4>
                    <p>ノート3ページを埋めることが目標とされています。ノート3ページは、英語では700〜800語に相当します。もちろん、英語と日本語では文字数が変わります。日本語では、1000〜1200文字が目安です。始めは1000文字を書くのは大変です。その場合は「書くことがない」とかでも良いのでとにかく目安まで書いてみてください。慣れてくれば誰でもスラスラと書けるようになるので安心してください。</p>
                <h3 class="title is-4" id="no-reading">モーニングページは８週間は読み返さない</h3>
                    <p>モーニングページは、最初の8週間は読み返さないのが基本です。最初は「脳のデトックス」として、文章は書き捨てのつもり書いてください。モーニングページに慣れてきた8週間後に改めて読み返してみてください。改めて自分の心に気づくはずです。</p>
                <h3 class="title is-4"  id="effect">モーニングページの効果</h3>
                    <p>モーニングページには以下のような効果があります。</p>
                <h4 class="title is-5">創造性の回復</h4>
                    <p>モーニングページは自分の心に素直になるための訓練です。普段自分で蓋をしてしまっている創造性を取り戻す手助けをします。</p>
                <h4 class="title is-5">思考の整理</h4>
                    <p>モーニングページは、原作では「脳の排泄」とよばれる効果があります。体が排泄して体をメンテナンスするように、脳にも感情や思考を調整する、排泄行為が必要です。それはモーニングページにあたります。モーニングページを体験した人は、思考が整いスッキリした感情を抱きます。</p>
                <h3 class="title is-4"  id="syukan">モーニングページを習慣にするには？</h3>
                    <p>モーニングページを習慣化する方法は、とにかく気負わず、書くことにプレッシャーを感じないことです。モーニングページは何を書いても良く、誰も見ないので（自分でさえも）ちゃんと書こうと考えず、頭に浮かんだままに書いてください。また、無理に毎日書こうと思う必要もありません。1000文字以上書くことが理想ですが、何も浮かばないならそのことを書けば良いのです。普段生活していると不可能ですが、モーニングページなら心のブロックを解除して思いのままに振舞うことができるのです。この開放感をぜひ味わってください。</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        userStatus() {
            return this.$store.getters.isSignIn;
        }
    },
    mounted(){
        const title = "モーニングページを始めよう｜エモーションダイアリー"
        const description = "モーニングページの紹介記事。モーニングページとは何かから、挫折せずに習慣化するコツを解説しています。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    }
}
</script>


<style scoped>
.morningpage{
    max-width: 1100px;
    margin:auto;
    padding: 20px;
}
.title{
    margin: 30px 0 30px 0;
}
li{
    padding:10px 0 0 0;
}
</style>